/** Tokens de marca Devssoft para CoreBase CRM. Fuente única de colores y tipografía. */

export const BRAND = {
  navy: "#0E2540",
  sky: "#5192C1",
  light: "#ACCDF4",
  bright: "#0366E1",
  white: "#FFFFFF",
};

export const NEUTRAL = {
  text: BRAND.navy,
  textSecondary: "#4A5D75",
  muted: "#8A99AB",
  border: "#D9E6F5",
  background: "#F4F8FD",
  tint: "#EAF2FC",
};

/** Colores con significado: se usan igual en tarjetas, chips y gráficas. */
export const SEMANTIC = {
  revenue: "#1E8E5A",
  revenueTint: "#E3F4EB",
  pipeline: BRAND.bright,
  pipelineTint: "#E6F0FD",
  potential: BRAND.sky,
  potentialTint: "#EAF2FC",
  expansion: BRAND.navy,
  warning: "#C77700",
  warningTint: "#FDF1DE",
  danger: "#C93838",
  dangerTint: "#FBE7E7",
  neutral: NEUTRAL.muted,
  neutralTint: "#EEF2F6",
};

export const CHART = {
  current: BRAND.bright,
  previous: BRAND.light,
  previousLine: BRAND.sky,
  grid: NEUTRAL.border,
  axis: NEUTRAL.textSecondary,
  series: [BRAND.bright, BRAND.navy, BRAND.sky, SEMANTIC.revenue, SEMANTIC.warning, "#3A76A3", BRAND.light, NEUTRAL.muted],
};

/** Progresión de etapas: del azul claro (inicio) al navy (cierre); Venta en verde, Perdido en gris. */
export const STAGE_COLORS = {
  nuevo: BRAND.sky,
  contactado: "#2F7FD6",
  interesado: BRAND.bright,
  propuesta_enviada: BRAND.navy,
  inscrito: SEMANTIC.revenue,
  perdido: NEUTRAL.muted,
};

export const STAGE_FALLBACK_COLORS = ["#3A76A3", "#1F3B5E", "#6FA8DC", "#0250B3"];

/** Etapas personalizadas reciben un color estable derivado de su id, igual en todas las vistas. */
export function stageColor(etapaId) {
  if (STAGE_COLORS[etapaId]) return STAGE_COLORS[etapaId];
  const hash = String(etapaId || "").split("").reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
  return STAGE_FALLBACK_COLORS[hash % STAGE_FALLBACK_COLORS.length];
}

export const WHATSAPP_GREEN = "#25D366";

export const FONT = {
  title: "'Poppins', 'Segoe UI', sans-serif",
  subtitle: "'Avenir Next LT Pro', 'Avenir Next', 'Nunito Sans', 'Segoe UI', sans-serif",
  body: "'Poppins', 'Segoe UI', sans-serif",
  detail: "'Akko Rounded Std', 'Nunito', 'Segoe UI', sans-serif",
};

export const BRAND_FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&family=Nunito+Sans:wght@400;600;700&family=Nunito:wght@400;600;700&display=swap";
